import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET, POST } from '../../Services/AxiosService';
import { CustomStringify } from "../../Helpers/CustomStringify";

export const fetchListSUPFG = createAsyncThunk(
  "SupplyDesignNameList/fetchListSUPFG",
  async ({ cmpdetail, UserDetail }, { rejectWithValue }) => {

    try {
      const result = await GET(`/supplydesign/${cmpdetail?.key}/${encodeURIComponent(UserDetail?.result?.user?.company_name)}`);
      return result?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.message)
    }
  }
);

const SupplyDesignNameListSlice = createSlice({
  name: "SupplyDesignNameList",
  initialState: {
    result: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchListSUPFG.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchListSUPFG.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.result = action.payload;
      })
      .addCase(fetchListSUPFG.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default SupplyDesignNameListSlice.reducer;
